import React from 'react';
import './PaiementHorsZone.scss';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

const PaiementHorsZone = ({
    onClose,
    open = true,
}) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className="my-dialog"
        >
            <DialogTitle>{t('en-dehors-de-votre-zone-geographique')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('desole-cette-seance-nest-pas-dans-votre-zone-geographique')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button type="submit" color="primary" onClick={onClose} >
                    {t('fermer')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PaiementHorsZone;
